import { makeStyles, withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";

export const useStyles = makeStyles((theme) => ({
  form: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "100%",
    },
  },
  topMargin: {
    marginTop: "50px",
  },
  title: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(30),
    fontWeight: 600,
    marginBottom: "26px",
  },
  paper: {
    backgroundColor: "inherit",
  },
  titleSeparator: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(22),
  },
  lineHr: {
    backgroundColor: "#E6E6E6",
    border: "none",
    height: "1px",
  },
  containerBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "start",
    padding: "44px 0 52px 0",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  formSwitch: {
    width: "164px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    display: "flex",
    justifyContent: "space-between",
    marginRight: 28,
    marginLeft: 0,
    "& .MuiFormControlLabel-label": {
      fontFamily: "Lato",
      fontSize: theme.typography.pxToRem(14),
      marginRight: 10,
      [theme.breakpoints.down("xs")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
  },
  descriptionText: {
    width: "266px",
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(12),
    color: "#747F9D",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginTop: 22,
      fontSize: theme.typography.pxToRem(16),
    },
  },
  manageText: {
    marginTop: 12,
  },
  detailsBtn: {
    color: "#F15A28",
    fontFamily: "Inter",
    textTransform: "none",
    fontWeight: 600,
    backgroundColor: "inherit",
    fontSize: theme.typography.pxToRem(14),
    marginLeft: 0,
    width: "164px",
    marginRight: 28,
    padding: "6px 12px",
    "&:hover": {
      backgroundColor: "inherit",
      color: "#F15A28",
    },
    [theme.breakpoints.down("xs")]: {
      width: "auto",
      fontSize: theme.typography.pxToRem(16),
    },
  },
  dialog: {
    "& .MuiPaper-root": {
      [theme.breakpoints.down("xs")]: {
        margin: 12,
        textAlign: "center",
      },
    },
  },
  dialogContent: { paddingBottom: 20 },
  dialogTitle: {
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.common.black,
    padding: "24px 24px 8px 24px",
  },
  dialogContentText: {
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    color: "#333333",
  },
  dialogActions: {
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
    },
  },
  btnConfirm: {
    fontFamily: "Inter",
    padding: "8px 24px",
    borderRadius: "100px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    marginRight: 10,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: "90%",
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: 16,
    },
  },
  btnCancel: {
    border: "none",
    padding: "10px 30px",
    borderRadius: "28px",
    fontFamily: "Inter",
    color: theme.palette.primary.main,
    "&:hover": {
      border: "none",
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
    },
  },
  snackbar: {
    right: "0px !important",
    top: "0px",
    transform: "translateX(0) !important",
    width: "363px",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  snackbarSuccess: {
    backgroundColor: "#E7F9EE",
    border: "1px solid #85DFA9",
  },
  snackbarError: {
    backgroundColor: "#E7F9EE",
    border: "1px solid #F11023",
  },
  alert: {
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(16),
    alignItems: "center",
    width: "100%",
    padding: "15px 16px",
    lineHeight: "24px",
    "&.MuiAlert-standardSuccess": {
      "& .MuiAlert-icon": {
        color: "#0ABF52",
        fontSize: theme.typography.pxToRem(24),
      },
    },
    "&.MuiAlert-standardError": {
      "& .MuiAlert-icon": {
        color: "#F11023",
        fontSize: theme.typography.pxToRem(24),
      },
    },
  },
}));

export const BlackSwitch = withStyles((theme) => ({
  root: {
    width: 24,
    height: 12,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.common.black,
    "&.Mui-disabled + $track": {
      opacity: 0.12,
      backgroundColor: theme.palette.common.white,
    },
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.common.black,
        borderColor: theme.palette.common.black,
      },
      "&.Mui-disabled + $track": {
        opacity: 0.12,
      },
    },
  },
  thumb: {
    width: 8,
    height: 8,
    boxShadow: "none",
  },
  track: {
    borderRadius: 16 / 2,
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
    border: `1px solid ${theme.palette.common.black}`,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
  [theme.breakpoints.down("xs")]: {
    root: {
      width: 51,
      height: 31,
    },
    switchBase: {
      padding: 1,
      color: theme.palette.common.white,
      "&$checked": {
        transform: "translateX(20px)",
      },
    },
    thumb: {
      width: 29,
      height: 29,
    },
    track: {
      borderRadius: 40 / 2,
      border: `1px solid ${theme.palette.common.black}`,
      backgroundColor: theme.palette.common.black,
    },
  },
}))(Switch);
